<template>
  <div class="el-card  pd20 special">
    <!-- form -->
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="招募标题" prop="title" :label-width="formLabelWidth">
        <el-input v-model="form.title" placeholder="请输入招募标题"></el-input>
      </el-form-item>
      <!-- 公众号二维码 -->
      <el-form-item label="公众号二维码" prop="qrcode_url" :label-width="formLabelWidth">
        <el-upload :show-file-list="false" :http-request="uploadImg" :before-upload="beforeAvatarUpload">
          <el-button size="small" type="primary">上传二维码图片（小于1MB）</el-button>
        </el-upload>
        <!--  -->
        <el-image class="up-image" :src="form.qrcode_url">
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
          <div slot="error" style="height:150px;line-height:150px;" class="image-slot error">
            请上传图片...
          </div>
        </el-image>
      </el-form-item>
      <!-- 富文本编辑器 -->
      <el-form-item label="招募内容" prop="content" :label-width="formLabelWidth">
        <vue-ueditor-wrap id="ue-box" v-model="form.content" :config="ueConfig" @ready="editorReady"></vue-ueditor-wrap>
      </el-form-item>
      <!--  -->
      <el-form-item :label-width="formLabelWidth">
        <el-button type="primary" @click="submitForm('form')">提交</el-button>
        <el-button @click="previewHandle">{{preview_text}}</el-button>
      </el-form-item>
    </el-form>
    <!-- 预览 -->
    <preview-mobile :html="form.content" :isPreview="preview"></preview-mobile>
  </div>
</template>
<script>
import {
  upload_image,
  setPage,
  getPage
} from "@/api/operating";
import VueUeditorWrap from "vue-ueditor-wrap";
import {
  isMain,
  isDev
} from "@u/tools";
import previewMobile from '@c/preview-mobile'
export default {
  data() {
      return {
        formLabelWidth: '120px',
        ueConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 300,
          // 初始容器宽度
          initialFrameWidth: "100%", // isMain()  ? "/test/system/static/UEditor/" : "/static/UEditor/"
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          // serverUrl: 'http://35.201.165.105:8000/controller.php',
          // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
          UEDITOR_HOME_URL: isDev() ? '/static/UEditor/' : (isMain() ? "/main/system/static/UEditor/" : "/test/system/static/UEditor/")
        },
        list: [],
        preview: false,
        preview_text: '预 览',
        form: {
          title: '',
          qrcode_url: '',
          content: ''
        },
        upload_type: '',
        //这是一个验证规则
        rules: {
          title: [{
            required: true, //是否必填
            message: '招募标题', //错误提示信息
            trigger: 'blur' //检验方式（blur为鼠标点击其他地方，）
          }],
          qrcode_url: [{
            required: true,
            message: '请上传二维码',
            trigger: 'change'
          }],
          content: [{
            required: true, //是否必填
            message: '请输入招募内容', //错误提示信息
            trigger: 'blur'
          }],
        }
      }
    },
    components: {
      previewMobile,
      VueUeditorWrap
    },
    methods: {
      // 预览
      previewHandle() {
        this.preview = !this.preview;
        this.preview_text = this.preview ? '收 起' : '预 览';
      },
      // 提交数据
      save() {
        setPage(this.form).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.$notify({
            title: '成功',
            message: '提交成功！',
            type: 'success'
          });
        });
      },
      //
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.save();
          } else {
            this.$message.warning('请检查数据是否为空？');
            return false;
          }
        });
      },
      // 上传图片前
      beforeAvatarUpload(file) {
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 1;

        if (!file.type === 'image/jpg' || !file.type === 'image/png' || !file.type === 'image/gif') {
          isJPG = false;
          this.$message.error('上传头像图片只能是 jpg/png/gif 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return isJPG && isLt2M;
      },
      // 上传图片
      uploadImg(param) {
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("image", param.file);
        // 携带当前讲座的id
        form.append("key", this.$route.path + '?type=' + this.upload_type);
        form.append("preserve", 1);

        // 上传图片接口
        upload_image(form).then((data) => {
          this.form.qrcode_url = data.image_url;
        });
      },
      pullData() {
        getPage()
        .then((data) => {
          this.form = data.page;
        });
      },
      editorReady(ue) {
        ue.execCommand("serverparam", (editor) => {
          return {
            key: this.$route.path + "?id=" + this.$route.query.id
          };
        });
        console.log("ueditor准备就绪");
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.special {
  .el-input,
  .el-textarea {
    width: 775px;
  }
  .price {
    width: 600px;
  }
}

.cancel-box {
  margin-bottom: 20px;
}

.up-image {
  margin: 20px auto auto;
  width: 187.5px;
  text-align: center;
  border-radius: 8px;
  .error {
    border-radius: 8px;
    background-color: rgba($color: #eeeeee, $alpha: .5);
  }
}

#ue-box {
  width: 800px;
  display: inline-block;
  line-height: 1;
}
</style>
